const root = 'connectStoreModal'

export const TestId = {
  platformTileWix: `${root}_platformTileWix`,
  platformTileShopify: `${root}_platformTileShopify`,
  storeConnectedMessage: `${root}-storeConnectedMessage`,
  submitButton: `${root}-submitButton`,
}
